module.exports = __webpack_public_path__ + "images/sns-account-page-2132315b14151fd2f1a5722a7b0311b2.png";